import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilterBar from "../../components/reports/ReportFilterBar";
import ReportTable from "../../components/reports/ReportTable";

export default function ProjectEffortReport() {
  const [rows, setRows] = useState([]);

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: ""
  });

  const fetchData = async () => {
    try {
      const res = await axios.get("/api/reports/project-effort", {
        params: filters
      });

      const data = res.data.rows || res.data.data || res.data || [];
      setRows(data);
    } catch (err) {
      console.error(err);
      setRows([]);
    }
  };

  const columns = [
    { field: "project", header: "Project" },
    { field: "hours", header: "Hours" }
  ];

  return (
    <>
      <h2>Project Effort</h2>

      <ReportFilterBar
        filters={["startDate", "endDate"]}
        values={filters}
        onChange={setFilters}
        onFetch={fetchData}
      />

      <ReportTable columns={columns} rows={rows} />
    </>
  );
}